import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-8">
            {aboutContent.title}
          </h2>
          <div className="flex flex-col gap-4 mb-10">
            {aboutContent.paragraphs.map((para, idx) => (
              <p key={idx} className="text-base text-foreground-600 leading-relaxed">{para}</p>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
            {aboutContent.stats.map((stat, idx) => (
              <div key={idx} className="text-center p-5 rounded-lg bg-background-100 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-extrabold font-heading text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}